import { IVisitorInterface } from '../models/IVisitorInterface';
import { Antlr4Utils } from '../models/antlr4-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
const dataflowParserVisitor = Antlr4Utils.getVisitorDefinition();

export abstract class BaseDSLVisitor extends (dataflowParserVisitor.DataflowParserVisitor as IVisitorInterface) {
    constructor(protected _tokenStream: any) {
        // eslint-disable-next-line constructor-super
        super();
    }

    protected _getText(node: any): string {
        return Antlr4Utils.getText(this._tokenStream, node);
    }

    protected visitChildren(context: any): any {
        context.children.forEach((child: any) => {
            this.visit(child);
        });
    }
}
